export default "__VITE_ASSET__BUsFMqJF__ 400w, __VITE_ASSET__DtFI1XBi__ 800w, __VITE_ASSET__C97QuAA8__ 1024w";